import { Flex, Image, Text } from "@chakra-ui/react";
import { Button, ButtonLink } from "@kiddocare-platform/portal-common/ui";
import type { FC } from "react";

const ErrorPage: FC = () => {
	return (
		<Flex direction="column" justifyContent="center" alignItems="center" minH="100vh" w="100%" bgColor="primaryParent.200" px={6}>
			<Flex direction="column" justifyContent="center" alignItems="center" gap={8}>
				<Image alt="Welcome" src="/images/welcome_image.svg" />
				<Text fontWeight="bold" fontFamily="heading" fontSize="2xl">Ops. Si è verificato un errore</Text>
				<Text fontSize="xl">Qualcosa è andato storto</Text>
				<Button colorPalette="primaryParent" onClick={() => window.location.assign(window.location.href)}>Ricarica la pagina</Button>
				<ButtonLink colorPalette="primaryParent" variant="plain" to="/">Torna alla home</ButtonLink>
			</Flex>
		</Flex>
	);
};

export default ErrorPage;